import type { ReactNode } from 'react';
import AdminProfileMenu from './AdminProfileMenu';

/* The one admin top bar.
   ---------------------------------------------------------------------------
   There were eight of these before — five different heights, three z-indexes,
   two border colours, some with a shadow and some without. Every /admin page
   now gets this one via AdminLayout, so the chrome no longer jumps when you
   walk between pages. Styling lives in styles/adminShell.css (`.ax-topbar`).

   The breadcrumb is inset below the xl breakpoint to clear the sidebar's
   floating hamburger button. */

export interface AdminTopbarProps {
  /** Breadcrumb parent — the sidebar section this page sits under. */
  section?: string;
  /** Breadcrumb leaf — the current page. */
  title: string;
  /** Controls placed at the end of the bar, before the profile menu. */
  actions?: ReactNode;
}

export default function AdminTopbar({ section, title, actions }: AdminTopbarProps) {
  return (
    <header className="ax-topbar">
      <span className="ax-crumb">
        {section && (<>{section}<span className="ax-crumb-sep">/</span></>)}
        <b>{title}</b>
      </span>
      <div className="ax-topbar-actions">
        {actions}
        <AdminProfileMenu />
      </div>
    </header>
  );
}
